// :: Dependencies
import { firestore, functions } from "@/config/firebase";
import { errorMessage, showMessage } from "@/services/MessageService";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import { RESET_DATA } from "./mutation-types";

export default {
  /**
   * This function saves the user data in firestore
   * @param {*} userData : contains the user information that is going to be saved in the database
   */
  async registerUser({ state, commit }, userData) {
    try {
      loaderStart();
      let access = {};
      state.checklist.forEach(element => {
        access[element.id] = element.value;
      });
      userData.userAccess = access;
      const newUser = await firestore("users").doc();
      newUser.set(userData);
      showMessage({
        message: "El usuario se ha registrado exitosamente",
        color: "success"
      });
      commit(RESET_DATA, userData);
      loaderDone();
    } catch (error) {
      errorMessage("Ha ocurrido un error al registrar el usuario");
    }
  },
  async updateUserAccess({ state, commit }, uid) {
    try {
      loaderStart();
      let access = {};
      state.checklist.forEach(element => {
        access[element.id] = element.value;
      });
      const newUser = await firestore("users").doc(uid);
      newUser.update({ userAccess: access });
      showMessage({
        message: "Los accesos del usuario fueron modificados correctamente",
        color: "success"
      });
      commit(RESET_DATA);
      loaderDone();
    } catch (error) {
      errorMessage("Error al actualizar los permisos del usuario");
    }
  },
  async updatePersonalInfo({ commit }, data) {
    try {
      loaderStart();
      const newUser = await firestore("users").doc(data.uid);
      await newUser.update({ ...data.userData });
      const updateUserData = functions.httpsCallable("updateUserFunction");
      await updateUserData(data);
      showMessage({
        message: "La información del usuario se actualizo",
        color: "success"
      });
      commit(RESET_DATA);
      loaderDone();
    } catch (error) {
      errorMessage("Error al actualizar los permisos del usuario");
    }
  },
  async deleteUser(_, uid) {
    try {
      loaderStart();
      const deleteUserFunction = functions.httpsCallable("deleteUserFunction");
      const result = await deleteUserFunction(uid);
      if (result)
        showMessage({
          message: "El usuario fue eleminado correctamente",
          color: "success"
        });
      else errorMessage("Error al eliminar usuario");
    } catch (error) {
      loaderDone();
      errorMessage("Error al eliminar usuario");
    }
  },
  resetDataState({ commit }) {
    commit(RESET_DATA);
  }
};
